<template>
    <div class="batch-launch-page">
        <div class="top-bar">
            <div class="mode-display">
                <span class="mode-display__breadcrumb mode-display__breadcrumb--current">批量签署</span>
            </div>
            <div class="step-wrap">
                <Steps :current="currentStep - 1" size="small">
                    <Step title="上传文件及签署方" />
                    <Step title="补充文件内容" />
                    <Step title="完成" />
                </Steps>
            </div>
            <div class="top-actions">
                <Button @click="goBack">返回发起方式</Button>
                <Button v-if="currentStep <= 3" @click="resetPage">重置</Button>
                <Button v-if="currentStep > 1 && currentStep < 3" @click="goPrev">上一步</Button>
                <Button v-if="currentStep < 3" type="primary" @click="goNext">{{ currentStep === 2 ? '发起合同' : '下一步'
                    }}</Button>
            </div>
        </div>

        <div class="content-wrap" v-if="currentStep < 3">
            <div class="left-panel card">
                <div v-if="currentStep === 1" class="upload-stage step-one">
                    <div class="upload-top-row">
                        <span class="upload-top-label">合同模板</span>
                        <Select v-model="formItem.template_id" clearable filterable placeholder="可选择模板快速发起"
                            style="width: 280px" @on-change="showMsg">
                            <Option v-for="item in tempList" :value="item.id" :key="'temp-' + item.id">{{
                                item.template_name }}</Option>
                        </Select>
                    </div>
                    <div class="upload-empty-wrap"
                        v-if="!formItem.contract_imgs || formItem.contract_imgs.length === 0">
                        <Upload :show-upload-list="false" :headers="headers" :action="imageAction"
                            :data="{ type: 1 }"
                            :format="['jpg', 'jpeg', 'png', 'doc', 'docx', 'pdf']" :on-format-error="handleFormatError"
                            :on-success="uploadSuccess" class="upload-empty-trigger">
                            <div class="upload-empty-center">
                                <Button type="primary">选择文件</Button>
                                <div class="upload-empty-tip">支持Word/PDF/小于20MB</div>
                            </div>
                        </Upload>
                    </div>
                    <div class="upload-box" v-else>
                        <div class="upload-ready">
                            <div class="upload-tip">{{ selectedTemplateName || '已上传文件' }}</div>
                            <div class="contract-pages-wrap upload-contract-preview">
                                <div class="contract-page-item contract-page--upload"
                                    v-for="(img, pageIndex) in formItem.contract_imgs"
                                    :key="'upload-page-' + pageIndex">
                                    <img :src="img" class="contract-page-img contract-img" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="preview-stage">
                    <div class="contract-pages-wrap">
                        <div class="contract-page contract-page-item" v-for="(img, pageIndex) in formItem.contract_imgs"
                            :key="'page-' + pageIndex">
                            <img :src="img" class="contract-page-img contract-img" />
                            <div class="component-overlay">
                                <!-- <div v-for="field in getPageFields(pageIndex)" :key="field.key" class="sign-field component-field"
                                    :style="{ left: field.left + 'px', top: field.top + 'px', width: field.width + 'px', height: field.height + 'px' }"
                                    :title="field.title" @mousedown="startFieldDrag(field, pageIndex, $event)">
                                    <span :style="{ userSelect: 'none', fontSize: (field.fontSize || 14) + 'px' }">{{ field.title }}</span>
                                    <div class="component-field-ops">
                                        <img
                                            class="component-field-op-icon"
                                            :src="componentActionIcons.edit"
                                            @mousedown.stop
                                            @click.stop="openEditField(field)"
                                        />
                                        <img
                                            class="component-field-op-icon"
                                            :src="componentActionIcons.remove"
                                            @mousedown.stop
                                            @click.stop="removeField(field.key)"
                                        />
                                    </div>
                                </div> -->
                                <div v-for="field in getPageFields(pageIndex)" :key="field.key" class="sign-field component-no-field"
                                    :style="{ left: (field.left+10) + 'px', top: (field.top+10) + 'px', width: field.width + 'px', height: field.height + 'px' }"
                                    :title="field.title">
                                    <span :style="{ userSelect: 'none', fontSize: (field.fontSize*1-1 || 14) + 'px' }">{{ field.title }}</span>
                                    <div class="component-field-ops"> 
                                        <img
                                            class="component-field-op-icon"
                                            :src="componentActionIcons.remove"
                                            @mousedown.stop
                                            @click.stop="removeField(field.key)"
                                        />
                                    </div>
                                   
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="right-panel card">
                <template v-if="currentStep === 1">
                    <div class="signer-item party-card"
                        :class="formItem.type === 1 ? 'signer-item--enterprise party-card--a' : 'signer-item--person party-card--b'">
                        <div class="signer-head party-head">
                            <span>合同参与人</span>
                            <Poptip placement="left-start" trigger="hover" transfer class="setting-poptip">
                                <span class="setting-link">设置
                                    <Icon type="ios-settings-outline" size="20" />
                                </span>
                                <div slot="content" class="setting-panel">
                                    <div class="setting-row">
                                        <div class="setting-label">签署者</div>
                                        <CheckboxGroup v-model="requirementElse">
                                            <Checkbox :label="1">个人</Checkbox>
                                            <Checkbox :label="2">企业</Checkbox>
                                        </CheckboxGroup>
                                    </div>
                                    <div class="setting-row">
                                        <div class="setting-label">签署时短信验证</div>
                                        <Checkbox v-model="formItem.is_sms">启用</Checkbox>
                                    </div>
                                    <div class="setting-row" v-if="requirementElse.indexOf(2) !== -1">
                                        <div class="setting-label">企业必须盖章</div>
                                        <Checkbox v-model="formItem.is_yinzhang">启用</Checkbox>
                                    </div>
                                    <div class="setting-row">
                                        <div class="setting-label">支持签署人数</div>
                                        <Input v-model="formItem.support_num" style="width: 150px"
                                            placeholder="请输入人数" />
                                        <span>人</span>
                                    </div>
                                    <div class="setting-row">
                                        <div class="setting-label">参与人是否签署</div>
                                        <!-- <i-switch v-model="partya_is_sign" :true-value="1" :false-value="0">
                                            <span slot="open">开启</span>
                                            <span slot="close">关闭</span>
                                        </i-switch> -->
                                        <div class="sort-switch">
                                            <i-switch v-model="partya_is_sign" size="large" :true-value="1" :false-value="0" class="sort-switch-control">
                                                <span slot="open" class="sort-switch-text">开启</span>
                                                <span slot="close" class="sort-switch-text">关闭</span>
                                            </i-switch> 
                                        </div>
                                    </div>
                                    <div class="setting-row" v-if="hasTemplateComponents">
                                        <div class="setting-label">参与人模版组件</div>
                                        <CheckboxGroup v-model="partya_arr" @on-change="onTemplateSelectChange('a')"
                                            class="setting-check-group">
                                            <Checkbox v-for="item in participantSettingOptions" :key="'a-' + item.id"
                                                :label="item.id">
                                                {{ item.title }}
                                            </Checkbox>
                                        </CheckboxGroup>
                                    </div>
                                    <div class="setting-row" v-if="hasTemplateComponents">
                                        <div class="setting-label">签署者模版组件</div>
                                        <CheckboxGroup v-model="partyb_arr" @on-change="onTemplateSelectChange('b')"
                                            class="setting-check-group">
                                            <Checkbox v-for="item in signerSettingOptions" :key="'b-' + item.id"
                                                :label="item.id" :disabled="partya_arr.map(id => String(id)).includes(String(item.id))">
                                                {{ item.title }}
                                            </Checkbox>
                                        </CheckboxGroup>
                                    </div>
                                </div>
                            </Poptip>
                        </div>
                        <div class="field-row party-field">
                            <div class="field-label party-field-label"><span class="req">*</span>参与主体</div>
                            <Select v-model="formItem.type" style="width: 170px">
                                <Option :value="0">个人</Option>
                                <Option :value="1">企业</Option>
                            </Select>
                        </div>
                        <div class="field-row party-field" v-if="formItem.type === 1">
                            <div class="field-label party-field-label"><span class="req">*</span>企业名称</div>
                            <Input v-model="formItem.corporate_name" placeholder="请输入企业名称" />
                        </div>
                        <div class="field-row party-field">
                            <div class="field-label party-field-label"><span class="req">*</span>{{ formItem.type === 1
                                ? '经办人' : '真实姓名' }}</div>
                            <Input v-model="formItem.name" :placeholder="formItem.type === 1 ? '请输入经办人姓名' : '请输入姓名'" />
                        </div>
                        <div class="field-row party-field">
                            <div class="field-label party-field-label"><span class="req">*</span>手机号</div>
                            <Input v-model="formItem.paraticipant_phone" placeholder="请输入手机号" />
                        </div>
                        <div class="field-row party-field">
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="component-tool">
                        <div class="tool-title">补充文件内容</div>
                        <div v-if="!hasTemplateComponents" class="component-empty-tip">当前模板无可用组件</div>
                        <div v-else>
                            <div class="component-signer-card">
                                <div class="component-signer-head">
                                    <Tag color="warning">参与人</Tag>
                                    <span class="component-signer-name">{{ formItem.type === 1 ?
                                        (formItem.corporate_name || formItem.name || '未命名') : (formItem.name || '未命名')
                                        }}</span>
                                    <span class="component-signer-count">已填写{{ participantFieldsCount }}处</span>
                                </div>
                                <div class="tool-grid">
                                    <div class="tool-item" v-for="tool in participantToolOptions"
                                        :key="'p-tool-' + tool.id"
                                        :class="{ 'tool-item--disabled': tool.disabledBySelf }"
                                        @click="addComponentField('a', tool)">
                                        <img :src="getToolImg(tool)" class="tool-item-img" @error="onToolImgError" />
                                        <span class="tool-item-text" :title="tool.title">{{ tool.title }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="component-signer-card" v-if="signerToolOptions.length">
                                <div class="component-signer-head">
                                    <Tag color="success">签署者</Tag>
                                    <!-- <span class="component-signer-name">{{ requirementElseText || '-' }}</span> -->
                                    <span class="component-signer-count">已填写{{ signerFieldsCount }}处</span>
                                </div>
                                <div class="tool-grid">
                                    <div class="tool-item" v-for="tool in signerToolOptions" :key="'s-tool-' + tool.id"
                                        :class="{ 'tool-item--disabled': tool.disabledBySelf }"
                                        @click="addComponentField('b', tool)">
                                        <img :src="getToolImg(tool)" class="tool-item-img" @error="onToolImgError" />
                                        <span class="tool-item-text" :title="tool.title">{{ tool.title }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>

        <div v-else class="done-card card">
            <img :src="publishSuccessImg" class="done-success-img" />
            <div class="done-text">发布成功</div>
            <Button type="primary" class="done-back-btn" @click="goBack">完成</Button>
        </div>

        <Modal v-model="launchModalVisible" title="发起合同" width="620">
            <Form :label-width="120">
                <FormItem label="任务名称" required>
                    <Input v-model="launchForm.task_name" placeholder="请输入任务名称" style="width: 325px" />
                </FormItem>
                <FormItem label="签约截止日期" required>
                    <DatePicker type="daterange" style="width: 325px" placeholder="请选择签约截止日期" :value="launchSignRange"
                        @on-change="changeLaunchSignRange" />
                </FormItem>
                <FormItem label="合同标签">
                    <Select v-model="launchForm.label_id" multiple style="width: 325px" clearable placeholder="请选择合同标签">
                        <Option v-for="item in ticketList" :value="item.id" :key="'launch-label-' + item.id">{{ item.name }}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="合同有效日期">
                    <DatePicker type="daterange" style="width: 325px" placeholder="请选择合同有效日期"
                        :value="launchEffectiveRange" @on-change="changeLaunchEffectiveRange" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="launchModalVisible = false">取消</Button>
                <Button type="primary" @click="submitLaunch">确定</Button>
            </div>
        </Modal>
        <Modal v-model="fieldModalVisible" title="编辑模板组件" width="420">
            <Form :label-width="88">
                <FormItem label="组件名称">
                    <Input v-model="fieldForm.title" placeholder="请输入组件名称" />
                </FormItem>
                <FormItem label="字体大小" v-if="fieldForm.editMode === 'font'">
                    <Input v-model="fieldForm.fontSize" placeholder="请输入字体大小" />
                </FormItem>
                <FormItem label="宽度" v-if="fieldForm.editMode === 'size'">
                    <Input v-model="fieldForm.width" placeholder="请输入宽度" />
                </FormItem>
                <FormItem label="高度" v-if="fieldForm.editMode === 'size'">
                    <Input v-model="fieldForm.height" placeholder="请输入高度" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="fieldModalVisible = false">取消</Button>
                <Button type="primary" @click="confirmFieldEdit">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { getCookies } from '@/utils/helper'
import config from '@/config/index'
import { createBatch, templist, edittempupdate, searchList, info, deletetmp } from '@/api/interFace'
import { withLaunchType, LAUNCH_TYPE } from '@/utils/launchVersion'
import { normalizeLaunchDateRange, resolveLaunchSignDateRange, LAUNCH_EFFECTIVE_DATE_MAX_DAYS } from '@/utils/launchDateRange'

const COMPONENT_IMG_MAP = {
    xingming: require('../../assets/imgs/xingming.png'),
    dianhua: require('../../assets/imgs/dianhua.png'),
    dizhi: require('../../assets/imgs/dizhi.png'),
    shenfenzhenghaoma: require('../../assets/imgs/shenfenzhenghaoma.png'),
    shenfenzhengzhaopian: require('../../assets/imgs/shenfenzhengzhaopian.png'),
    jine: require('../../assets/imgs/jine.png'),
    gongzhang: require('../../assets/imgs/gongzhang.png'),
    riqi: require('../../assets/imgs/riqi.png'),
    gongsimingcheng: require('../../assets/imgs/gongsimingcheng.png')
}
const COMPONENT_ACTION_IMG_MAP = {
    edit: require('../../assets/imgs/xiangqing1.png'),
    remove: require('../../assets/imgs/shanchu.png')
}
const PUBLISH_SUCCESS_IMG = require('../../assets/images/newsign/fabuchenggong.png')

export default {
    name: 'signBatchLaunch',
    data() {
        return {
            draftKey: 'sign_batch_launch_draft_v1',
            currentStep: 1,
            formItem: {
                task_name: '',
                name: '',
                is_sms: false,
                document_type: '',
                upload_type: '',
                source_file_id: '',
                parse_file_id: '',
                start_time: '',
                end_time: '',
                paraticipant_phone: '',
                is_yinzhang: false,
                support_num: 0,
                contract_imgs: [],
                corporate_name: '',
                requirement: '',
                type: 1,
                template_id: '',
                label_id: [],
                start_expired: '',
                end_expired: ''
            },
            imageAction: config.apiUrl + '/adminapi/common/uploads',
            headers: { 'Authori-zation': getCookies('token') },
            ticketList: [],
            tempList: [],
            timeVal: [],
            expiredVal: [],
            accessories_url: '',
            annex_file_id: '',
            annex_img_ids: [],
            accessories_img: [],
            requirementElse: [1],
            partya_is_sign: 0,
            partya_arr: [],
            partyb_arr: [],
            partya_template_cg_arr: [],
            partyb_template_cg_arr: [],
            componentFields: [],
            dragState: {
                active: false,
                key: '',
                pageIndex: 0,
                startX: 0,
                startY: 0,
                startLeft: 0,
                startTop: 0
            },
            submiting: false,
            fieldModalVisible: false,
            editFieldKey: '',
            fieldForm: {
                title: '',
                fontSize: 14,
                width: 120,
                height: 32,
                editMode: 'font'
            },
            launchModalVisible: false,
            launchForm: {
                task_name: '',
                label_id: []
            },
            launchSignRange: [],
            launchEffectiveRange: [],
            publishSuccessImg: PUBLISH_SUCCESS_IMG,
            componentActionIcons: COMPONENT_ACTION_IMG_MAP
        }
    },
    computed: {
        hasTemplateComponents() {
            return this.unifiedTemplateComponents.length > 0
        },
        unifiedTemplateComponents() {
            const map = new Map()
            const pushRow = (item) => {
                const id = String(this.normalizeComponentId(item && item.id))
                if (!id) return
                if (!map.has(id)) {
                    map.set(id, {
                        ...item,
                        id: this.normalizeComponentId(item.id),
                        img: item.img || this.resolveComponentImg(item)
                    })
                }
            }
            ;(Array.isArray(this.partya_template_cg_arr) ? this.partya_template_cg_arr : []).forEach(pushRow)
            ;(Array.isArray(this.partyb_template_cg_arr) ? this.partyb_template_cg_arr : []).forEach(pushRow)
            return Array.from(map.values())
        },
        selectedTemplateName() {
            const row = this.tempList.find(item => String(item.id) === String(this.formItem.template_id))
            return row ? row.template_name : ''
        },
        requirementElseText() {
            const map = { 1: '个人', 2: '企业' }
            return (this.requirementElse || []).map(id => map[id]).join('、')
        },
        participantToolOptions() {
            if (!this.partya_is_sign) return []
            const ownSelected = this.partya_arr.map(id => String(this.normalizeComponentId(id)))
            const signerSelected = this.partyb_arr.map(id => String(this.normalizeComponentId(id)))
            const occupiedSet = new Set([...ownSelected, ...signerSelected])
            const addedIds = this.componentFields
                .filter(item => item.party === 'a')
                .map(item => String(this.normalizeComponentId(item.id)))
            return this.unifiedTemplateComponents
                .filter((item) => {
                    const cid = String(this.normalizeComponentId(item.id))
                    const selectedByParticipant = ownSelected.includes(cid)
                    const selectedBySigner = signerSelected.includes(cid)
                    const unassigned = !occupiedSet.has(cid)
                    return !selectedBySigner && (selectedByParticipant || unassigned)
                })
                .map(item => ({
                    ...item,
                    img: item.img || this.resolveComponentImg(item),
                    disabledBySelf: addedIds.includes(String(this.normalizeComponentId(item.id)))
                }))
        },
        signerToolOptions() {
            const ownSelected = this.partyb_arr.map(id => String(this.normalizeComponentId(id)))
            const participantIds = this.partya_arr.map(id => String(this.normalizeComponentId(id)))
            const occupiedSet = new Set([...ownSelected, ...participantIds])
            const signerAddedIds = this.componentFields
                .filter(item => item.party === 'b')
                .map(item => String(this.normalizeComponentId(item.id)))
            return this.unifiedTemplateComponents
                .filter((item) => {
                    const cid = String(this.normalizeComponentId(item.id))
                    const selectedBySigner = ownSelected.includes(cid)
                    const selectedByParticipant = participantIds.includes(cid)
                    const unassigned = !occupiedSet.has(cid)
                    return !selectedByParticipant && (selectedBySigner || unassigned)
                })
                .map(item => ({
                    ...item,
                    img: item.img || this.resolveComponentImg(item),
                    disabledBySelf: signerAddedIds.includes(String(this.normalizeComponentId(item.id)))
                }))
        },
        participantSettingOptions() {
            const signerIds = this.partyb_arr.map(id => String(this.normalizeComponentId(id)))
            return this.unifiedTemplateComponents.filter(item => !signerIds.includes(String(this.normalizeComponentId(item.id))))
        },
        signerSettingOptions() {
            const participantIds = this.partya_arr.map(id => String(this.normalizeComponentId(id)))
            return this.unifiedTemplateComponents.filter(item => !participantIds.includes(String(this.normalizeComponentId(item.id))))
        },
        participantFieldsCount() {
            return this.componentFields.filter(item => item.party === 'a').length
        },
        signerFieldsCount() {
            return this.componentFields.filter(item => item.party === 'b').length
        }
    },
    created() {
        this.$store.commit('changePollingSpin', false)
        this.getTem()
        this.getTickets()
        this.loadDraft()
        this.initDefaultLaunchSignDate()
    },
    beforeDestroy() {
        this.unbindDrag()
    },
    watch: {
        currentStep() { this.saveDraft() },
        formItem: {
            deep: true,
            handler() { this.saveDraft() }
        },
        requirementElse: {
            deep: true,
            handler() { this.saveDraft() }
        },
        partya_arr: {
            deep: true,
            handler() { this.saveDraft() }
        },
        partyb_arr: {
            deep: true,
            handler() { this.saveDraft() }
        },
        partya_is_sign(val) {
            if (!val) {
                this.partya_arr = []
                this.componentFields = this.componentFields.filter(item => item.party !== 'a')
            }
            this.saveDraft()
        },
        componentFields: {
            deep: true,
            handler() { this.saveDraft() }
        }
    },
    methods: {
        normalizeComponentId(value) {
            if (value === undefined || value === null || value === '') return ''
            const num = Number(value)
            return Number.isFinite(num) ? num : String(value)
        },
        buildSubmitTemplateComponents(selectedIds = []) {
            const selectedSet = new Set(
                (Array.isArray(selectedIds) ? selectedIds : []).map(id => String(this.normalizeComponentId(id)))
            )
            return this.unifiedTemplateComponents
                .filter(item => selectedSet.has(String(this.normalizeComponentId(item.id))))
                .map((item) => {
                    const next = { ...item, isdisabled: true }
                    delete next.img
                    delete next.disabledBySelf
                    return next
                })
        },
        getFieldEditModeByType(type) {
            const numericType = Number(type)
            return numericType === 4 || numericType === 6 ? 'size' : 'font'
        },
        getComponentTypeById(componentId) {
            const targetId = String(this.normalizeComponentId(componentId))
            const row = this.unifiedTemplateComponents.find(item => String(this.normalizeComponentId(item.id)) === targetId)
            return row ? Number(row.type) : NaN
        },
        goBack() {
            this.$router.push({ path: '/sign/launch' })
        },
        resetPage() {
            this.currentStep = 1
            this.formItem = {
                task_name: '',
                name: '',
                is_sms: false,
                document_type: '',
                upload_type: '',
                source_file_id: '',
                parse_file_id: '',
                start_time: '',
                end_time: '',
                paraticipant_phone: '',
                is_yinzhang: false,
                support_num: 0,
                contract_imgs: [],
                corporate_name: '',
                requirement: '',
                type: 1,
                template_id: '',
                label_id: [],
                start_expired: '',
                end_expired: ''
            }
            this.timeVal = []
            this.expiredVal = []
            this.initDefaultLaunchSignDate()
            this.requirementElse = [1]
            this.partya_is_sign = 0
            this.partya_arr = []
            this.partyb_arr = []
            this.partya_template_cg_arr = []
            this.partyb_template_cg_arr = []
            this.componentFields = []
            this.submiting = false
            this.clearDraft()
        },
        goPrev() {
            if (this.currentStep > 1) this.currentStep -= 1
        },
        goNext() {
            if (this.currentStep === 1) {
                if (!this.formItem.contract_imgs || this.formItem.contract_imgs.length === 0) {
                    this.$Message.warning('请先上传或选择模板文件')
                    return
                }
                if (!this.validateStepOne()) return
                this.ensureComponentFieldsFromSelection()
                this.currentStep = 2
                return
            }
            if (this.currentStep === 2) {
                this.openLaunchModal()
            }
        },
        initDefaultLaunchSignDate() {
            const resolved = resolveLaunchSignDateRange(this.formItem.start_time, this.formItem.end_time)
            this.formItem.start_time = resolved.start
            this.formItem.end_time = resolved.end
        },
        openLaunchModal() {
            this.launchForm.task_name = this.formItem.task_name || ''
            this.launchForm.label_id = Array.isArray(this.formItem.label_id) ? this.formItem.label_id : []
            const resolved = resolveLaunchSignDateRange(this.formItem.start_time, this.formItem.end_time)
            this.formItem.start_time = resolved.start
            this.formItem.end_time = resolved.end
            this.launchSignRange = resolved.range
            this.launchEffectiveRange = [this.formItem.start_expired, this.formItem.end_expired].filter(Boolean)
            this.launchModalVisible = true
        },
        changeLaunchSignRange(e) {
            const result = normalizeLaunchDateRange(Array.isArray(e) ? e : [])
            if (result.exceeded) {
                this.$Message.warning(result.message)
            }
            this.launchSignRange = result.start && result.end ? [result.start, result.end] : (Array.isArray(e) ? e : [])
        },
        changeLaunchEffectiveRange(e) {
            const result = normalizeLaunchDateRange(Array.isArray(e) ? e : [], LAUNCH_EFFECTIVE_DATE_MAX_DAYS)
            if (result.exceeded) {
                this.$Message.warning(result.message)
            }
            this.launchEffectiveRange = result.start && result.end ? [result.start, result.end] : (Array.isArray(e) ? e : [])
        },
        submitLaunch() {
            if (!this.launchForm.task_name) {
                this.$Message.warning('请填写任务名称')
                return
            }
            if (!Array.isArray(this.launchSignRange) || this.launchSignRange.length !== 2 || !this.launchSignRange[0] || !this.launchSignRange[1]) {
                this.$Message.warning('请选择签约截止日期')
                return
            }
            if (
                this.launchSignRange[1] &&
                this.launchEffectiveRange &&
                this.launchEffectiveRange[1] &&
                (new Date(this.launchSignRange[1]).getTime() > new Date(this.launchEffectiveRange[1]).getTime())
            ) {
                this.$Message.warning('合同有效日期结束时间必须大于签约截止日期结束时间')
                return
            }
            this.formItem.task_name = this.launchForm.task_name
            this.formItem.label_id = Array.isArray(this.launchForm.label_id) ? this.launchForm.label_id : []
            this.formItem.start_time = this.launchSignRange[0] || ''
            this.formItem.end_time = this.launchSignRange[1] || ''
            this.formItem.start_expired = this.launchEffectiveRange[0] || ''
            this.formItem.end_expired = this.launchEffectiveRange[1] || ''
            this.launchModalVisible = false
            this.submitBatch()
        },
        saveDraft() {
            try {
                const payload = {
                    currentStep: this.currentStep,
                    formItem: this.formItem,
                    requirementElse: this.requirementElse,
                    partya_is_sign: this.partya_is_sign,
                    partya_arr: this.partya_arr,
                    partyb_arr: this.partyb_arr,
                    partya_template_cg_arr: this.partya_template_cg_arr,
                    partyb_template_cg_arr: this.partyb_template_cg_arr,
                    componentFields: this.componentFields,
                    launchForm: this.launchForm,
                    launchSignRange: this.launchSignRange,
                    launchEffectiveRange: this.launchEffectiveRange
                }
                localStorage.setItem(this.draftKey, JSON.stringify(payload))
            } catch (e) {
                console.error(e)
            }
        },
        loadDraft() {
            try {
                const raw = localStorage.getItem(this.draftKey)
                if (!raw) return
                const draft = JSON.parse(raw)
                this.currentStep = draft.currentStep || 1
                this.formItem = draft.formItem || this.formItem
                this.requirementElse = Array.isArray(draft.requirementElse) ? draft.requirementElse : [1]
                this.partya_is_sign = draft.partya_is_sign === 1 ? 1 : 0
                this.partya_arr = Array.isArray(draft.partya_arr) ? draft.partya_arr : []
                this.partyb_arr = Array.isArray(draft.partyb_arr) ? draft.partyb_arr : []
                this.partya_template_cg_arr = Array.isArray(draft.partya_template_cg_arr) ? draft.partya_template_cg_arr : []
                this.partyb_template_cg_arr = Array.isArray(draft.partyb_template_cg_arr) ? draft.partyb_template_cg_arr : []
                this.componentFields = Array.isArray(draft.componentFields) ? draft.componentFields : []
                this.launchForm = draft.launchForm || this.launchForm
                this.launchSignRange = Array.isArray(draft.launchSignRange) ? draft.launchSignRange : []
                this.launchEffectiveRange = Array.isArray(draft.launchEffectiveRange) ? draft.launchEffectiveRange : []
            } catch (e) {
                console.error(e)
            }
        },
        clearDraft() {
            try {
                localStorage.removeItem(this.draftKey)
            } catch (e) {
                console.error(e)
            }
        },
        getTickets() {
            searchList().then(res => {
                this.ticketList = res.data || []
            }).catch(() => { })
        },
        getTem() {
            templist({ status: 'all', type: 1 }).then(res => {
                this.tempList = res.data.data || []
            }).catch(() => { })
        },
        resolveComponentImg(item = {}) {
            const typeMap = {
                0: COMPONENT_IMG_MAP.xingming,
                1: COMPONENT_IMG_MAP.dianhua,
                2: COMPONENT_IMG_MAP.dizhi,
                3: COMPONENT_IMG_MAP.shenfenzhenghaoma,
                4: COMPONENT_IMG_MAP.shenfenzhengzhaopian,
                5: COMPONENT_IMG_MAP.jine,
                6: COMPONENT_IMG_MAP.gongzhang,
                7: COMPONENT_IMG_MAP.riqi,
                8: COMPONENT_IMG_MAP.gongsimingcheng
            }
            if (typeMap[item.type] || typeMap[Number(item.type)]) return typeMap[item.type] || typeMap[Number(item.type)]
            const title = String(item.title || '')
            if (title.indexOf('姓名') > -1) return COMPONENT_IMG_MAP.xingming
            if (title.indexOf('电话') > -1 || title.indexOf('手机') > -1) return COMPONENT_IMG_MAP.dianhua
            if (title.indexOf('地址') > -1) return COMPONENT_IMG_MAP.dizhi
            if (title.indexOf('身份证号码') > -1) return COMPONENT_IMG_MAP.shenfenzhenghaoma
            if (title.indexOf('身份证照片') > -1) return COMPONENT_IMG_MAP.shenfenzhengzhaopian
            if (title.indexOf('金额') > -1) return COMPONENT_IMG_MAP.jine
            if (title.indexOf('公章') > -1) return COMPONENT_IMG_MAP.gongzhang
            if (title.indexOf('日期') > -1) return COMPONENT_IMG_MAP.riqi
            if (title.indexOf('公司名称') > -1) return COMPONENT_IMG_MAP.gongsimingcheng
            return COMPONENT_IMG_MAP.xingming
        },
        mapTemplateComponents(list = []) {
            let source = list
            if (typeof source === 'string') {
                try {
                    source = JSON.parse(source)
                } catch (e) {
                    source = []
                }
            }
            if (!Array.isArray(source)) source = []
            return source.map((item, index) => {
                const normalized = item && typeof item === 'object' ? item : {}
                const id = normalized.id || normalized.component_id || normalized.cg_id || `tmp_${index}_${Date.now()}`
                return {
                    ...normalized,
                    id,
                    img: this.resolveComponentImg(normalized)
                }
            })
        },
        getToolImg(tool = {}) {
            return tool.img || this.resolveComponentImg(tool) || COMPONENT_IMG_MAP.xingming
        },
        onToolImgError(evt) {
            if (evt && evt.target) {
                evt.target.src = COMPONENT_IMG_MAP.xingming
            }
        },
        getApiData(res) {
            const raw = (res && res.data) || {}
            if (raw && typeof raw === 'object' && !Array.isArray(raw) && raw.data && typeof raw.data === 'object' && !Array.isArray(raw.data)) {
                return raw.data
            }
            return raw
        },
        validateStepOne() {
            if (this.formItem.type === 1 && !String(this.formItem.corporate_name || '').trim()) {
                this.$Message.warning('请填写企业名称')
                return false
            }
            if (!String(this.formItem.name || '').trim()) {
                this.$Message.warning(this.formItem.type === 1 ? '请填写经办人姓名' : '请填写真实姓名')
                return false
            }
            if (!/^1[3-9]\d{9}$/.test(String(this.formItem.paraticipant_phone || '').trim())) {
                this.$Message.warning('请填写正确的手机号')
                return false
            }
            if (!Number(this.formItem.support_num) || Number(this.formItem.support_num) <= 0) {
                // this.$Message.warning('请填写支持签署人数')
                // return false
                this.$Message.warning({ 
                    content: '请在设置中先填写支持签署人数！',
                    duration: 8
                })
                return false
            }
            return true
        },
        handleFormatError() {
            this.$Message.warning('暂不支持上传此类型文件')
        },
        uploadSuccess(e) {
            const msg = this.$Message.loading({ content: '上传中...', duration: 0 })
            edittempupdate({ path: e.data.src }).then(res => {
                const data = this.getApiData(res)
                this.formItem.document_type = data.document_type
                this.formItem.upload_type = data.upload_type
                this.formItem.parse_file_id = data.parse_file_id
                this.formItem.source_file_id = data.source_file_id || e.data.source_file_id || ''
                this.formItem.contract_imgs = Array.isArray(data.imgs) ? data.imgs : (Array.isArray(data.contract_imgs) ? data.contract_imgs : [])
                this.formItem.template_id = ''
                const componentSource = data.components_arr || data.component_arr || data.assembly_arr || []
                const components = this.mapTemplateComponents(componentSource)
                this.partya_template_cg_arr = JSON.parse(JSON.stringify(components))
                this.partyb_template_cg_arr = JSON.parse(JSON.stringify(components))
                this.partya_arr = this.partya_is_sign ? components.map(item => item.id) : []
                this.partyb_arr = []
                this.componentFields = []
                this.$Message.success(e.msg || '上传成功')
                setTimeout(msg, 100)
            }).catch(err => {
                setTimeout(msg, 100)
                this.$Message.error((err && err.msg) || '上传失败')
            })
        },
        previewContract() {
            const url = (this.formItem.contract_imgs && this.formItem.contract_imgs[0]) || ''
            if (!url) return
            window.open(url)
        },
        removeContract() {
            deletetmp({ contract_path: this.formItem.contract_imgs || [] }).finally(() => {
                this.formItem.contract_imgs = []
                this.formItem.parse_file_id = ''
                this.formItem.source_file_id = ''
                this.formItem.template_id = ''
                this.partya_arr = []
                this.partyb_arr = []
                this.partya_template_cg_arr = []
                this.partyb_template_cg_arr = []
                this.componentFields = []
            })
        },
        showMsg(templateId) {
            if (!templateId) {
                this.partya_template_cg_arr = []
                this.partyb_template_cg_arr = []
                this.partya_arr = []
                this.partyb_arr = []
                return
            }
            const msg = this.$Message.loading({ content: '模板加载中...', duration: 0 })
            info({ id: templateId }).then(res => {
                const data = this.getApiData(res)
                this.formItem.document_type = data.document_type
                this.formItem.upload_type = data.upload_type
                this.formItem.contract_imgs = Array.isArray(data.contract_imgs) ? data.contract_imgs : []
                this.formItem.parse_file_id = data.parse_file_id || ''
                this.formItem.source_file_id = data.source_file_id || ''
                const componentSource = data.components_arr || data.component_arr || data.assembly_arr || []
                const components = this.mapTemplateComponents(componentSource)
                this.partya_template_cg_arr = JSON.parse(JSON.stringify(components))
                this.partyb_template_cg_arr = JSON.parse(JSON.stringify(components))
                this.partya_arr = this.partya_is_sign ? components.map(item => item.id) : []
                this.partyb_arr = []
                this.componentFields = []
                setTimeout(msg, 100)
            }).catch(err => {
                setTimeout(msg, 100)
                this.$Message.error((err && err.msg) || '模板加载失败')
            })
        },
        isComponentOccupied(componentId, party) {
            const id = String(componentId)
            if (party === 'a') {
                return this.partyb_arr.map(item => String(item)).includes(id)
            }
            return this.partya_arr.map(item => String(item)).includes(id)
        },
        onTemplateSelectChange(party) {
            if (party === 'a' && !this.partya_is_sign && this.partya_arr.length) {
                this.partya_arr = []
                this.$Message.warning('请先开启参与方签署开关')
                return
            }
            if (party === 'a') {
                const selected = this.partya_arr.map(item => String(this.normalizeComponentId(item)))
                const before = this.partyb_arr.length
                this.partyb_arr = this.partyb_arr.filter(item => !selected.includes(String(this.normalizeComponentId(item))))
                if (before !== this.partyb_arr.length) {
                    this.$Message.warning('参与方已选择的模板组件，签署者不可重复选择')
                }
                const selectedMap = this.partya_arr.map(item => String(this.normalizeComponentId(item)))
                this.componentFields = this.componentFields.filter(item => item.party !== 'a' || selectedMap.includes(String(this.normalizeComponentId(item.id))))
            }
            if (party === 'b') {
                const selected = this.partyb_arr.map(item => String(this.normalizeComponentId(item)))
                const before = this.partya_arr.length
                this.partya_arr = this.partya_arr.filter(item => !selected.includes(String(this.normalizeComponentId(item))))
                if (before !== this.partya_arr.length) {
                    this.$Message.warning('签署方已选择的模板组件，参与者不可重复选择')
                }
                const selectedMap = this.partyb_arr.map(item => String(this.normalizeComponentId(item)))
                this.componentFields = this.componentFields.filter(item => item.party !== 'b' || selectedMap.includes(String(this.normalizeComponentId(item.id))))
            }
            // 双向互斥兜底：同一组件始终只能归属一方
            const aSet = new Set(this.partya_arr.map(id => String(this.normalizeComponentId(id))))
            this.partyb_arr = this.partyb_arr.filter(id => !aSet.has(String(this.normalizeComponentId(id))))
        },
        ensureComponentFieldsFromSelection() {
            if (this.componentFields.length) return
            const rows = []
            const addRows = (list, ids, party) => {
                const idMap = ids.map(id => String(this.normalizeComponentId(id)))
                if (!idMap.length) return
                list.forEach(item => {
                    if (!idMap.includes(String(this.normalizeComponentId(item.id)))) return
                    let page = Number(
                        item.pageIndex !== undefined ? item.pageIndex
                            : item.page !== undefined ? item.page
                                : item.page_num !== undefined ? item.page_num
                                    : item.page_index !== undefined ? item.page_index
                                        : 1
                    )
                    if (page >= 1) page = page - 1
                    const width = Number(item.width || 120)
                    const height = Number(item.height || 32)
                    const left = Math.max(0, Math.min(800 - width, Number(item.position_x || 0)))
                    let top = Number(item.position_y || 0)
                    if (top > 1132) top = top - page * 1132
                    top = Math.max(0, Math.min(1132 - height, top))
                    rows.push({
                        key: `${party}_${item.id}`,
                        id: this.normalizeComponentId(item.id),
                        party,
                        type: Number(item.type),
                        title: `${item.title || ''}`,
                        width,
                        height,
                        fontSize: Number(item.font_size || item.fontSize || 14),
                        left,
                        top,
                        pageIndex: page
                    })
                })
            }
            addRows(this.unifiedTemplateComponents, this.partya_arr, 'a')
            addRows(this.unifiedTemplateComponents, this.partyb_arr, 'b')
            this.componentFields = rows
        },
        addComponentField(party, tool) {
            if (tool && tool.disabledBySelf) {
                this.$Message.warning('该组件已添加到合同页面')
                return
            }
            const targetId = String(this.normalizeComponentId(tool.id))
            const existsByOtherParty = this.componentFields.some(
                item => String(this.normalizeComponentId(item.id)) === targetId && item.party !== party
            )
            if (existsByOtherParty) {
                this.$Message.warning('该组件已被另一方添加')
                return
            }
            const exists = this.componentFields.some(item => String(this.normalizeComponentId(item.id)) === targetId && item.party === party)
            if (exists) {
                this.$Message.warning('该组件已添加到合同页面')
                return
            }
            // 第二步添加也会确认组件归属，确保双方互斥
            if (party === 'a') {
                if (!this.partya_arr.map(id => String(this.normalizeComponentId(id))).includes(targetId)) {
                    this.partya_arr = this.partya_arr.concat([this.normalizeComponentId(tool.id)])
                }
                this.partyb_arr = this.partyb_arr.filter(id => String(this.normalizeComponentId(id)) !== targetId)
            } else if (party === 'b') {
                if (!this.partyb_arr.map(id => String(this.normalizeComponentId(id))).includes(targetId)) {
                    this.partyb_arr = this.partyb_arr.concat([this.normalizeComponentId(tool.id)])
                }
                this.partya_arr = this.partya_arr.filter(id => String(this.normalizeComponentId(id)) !== targetId)
            }
            const key = `${party}_${targetId}_${Date.now()}`
            let page = Number(
                tool.pageIndex !== undefined ? tool.pageIndex
                    : tool.page !== undefined ? tool.page
                        : tool.page_num !== undefined ? tool.page_num
                            : tool.page_index !== undefined ? tool.page_index
                                : 1
            )
            if (page >= 1) page = page - 1
            const width = Number(tool.width || 120)
            const height = Number(tool.height || 32)
            const left = Math.max(0, Math.min(800 - width, Number(tool.position_x || 0)))
            let top = Number(tool.position_y || 0)
            if (top > 1132) top = top - page * 1132
            top = Math.max(0, Math.min(1132 - height, top))
            this.componentFields.push({
                key,
                id: this.normalizeComponentId(tool.id),
                party,
                type: Number(tool.type),
                title: `${tool.title || ''}`,
                width,
                height,
                fontSize: Number(tool.font_size || tool.fontSize || 14),
                pageIndex: page,
                left,
                top
            })
        },
        openEditField(field) {
            this.editFieldKey = field.key
            const fieldType = Number.isFinite(Number(field.type)) ? Number(field.type) : this.getComponentTypeById(field.id)
            this.fieldForm = {
                title: field.title || '',
                fontSize: Number(field.fontSize || 14),
                width: Number(field.width || 120),
                height: Number(field.height || 32),
                editMode: this.getFieldEditModeByType(fieldType)
            }
            this.fieldModalVisible = true
        },
        confirmFieldEdit() {
            const idx = this.componentFields.findIndex(item => item.key === this.editFieldKey)
            if (idx === -1) {
                this.fieldModalVisible = false
                return
            }
            const row = this.componentFields[idx]
            const title = String(this.fieldForm.title || '').trim() || row.title
            const width = Math.max(32, Number(this.fieldForm.width) || row.width)
            const height = Math.max(24, Number(this.fieldForm.height) || row.height)
            const maxLeft = Math.max(0, 800 - width)
            const maxTop = Math.max(0, 1132 - height)
            const nextRow = { ...row, title }
            if (this.fieldForm.editMode === 'size') {
                nextRow.width = width
                nextRow.height = height
                nextRow.left = Math.min(maxLeft, Math.max(0, Number(row.left || 0)))
                nextRow.top = Math.min(maxTop, Math.max(0, Number(row.top || 0)))
            } else {
                nextRow.fontSize = Number(this.fieldForm.fontSize) || row.fontSize || 14
            }
            this.$set(this.componentFields, idx, nextRow)
            this.fieldModalVisible = false
        },
        removeField(fieldKey) {
            const row = this.componentFields.find(item => item.key === fieldKey)
            this.componentFields = this.componentFields.filter(item => item.key !== fieldKey)
            if (!row) return
            const removedId = String(this.normalizeComponentId(row.id))
            const stillExists = this.componentFields.some(
                item => String(this.normalizeComponentId(item.id)) === removedId
            )
            // 删除后若该组件已不在画布上，则回到“未分配”，两方都可见
            if (!stillExists) {
                this.partya_arr = this.partya_arr.filter(id => String(this.normalizeComponentId(id)) !== removedId)
                this.partyb_arr = this.partyb_arr.filter(id => String(this.normalizeComponentId(id)) !== removedId)
            }
        },
        startFieldDrag(field, pageIndex, evt) {
            evt.preventDefault()
            this.dragState = {
                active: true,
                key: field.key,
                pageIndex,
                startX: evt.clientX,
                startY: evt.clientY,
                startLeft: field.left,
                startTop: field.top
            }
            document.addEventListener('mousemove', this.onDragMove)
            document.addEventListener('mouseup', this.onDragUp)
        },
        onDragMove(evt) {
            if (!this.dragState.active) return
            const idx = this.componentFields.findIndex(item => item.key === this.dragState.key)
            if (idx === -1) return
            const row = this.componentFields[idx]
            const deltaX = evt.clientX - this.dragState.startX
            const deltaY = evt.clientY - this.dragState.startY
            const nextLeft = Math.max(0, Math.min(800 - row.width, this.dragState.startLeft + deltaX))
            const nextTop = Math.max(0, Math.min(1132 - row.height, this.dragState.startTop + deltaY))
            this.$set(this.componentFields, idx, { ...row, left: nextLeft, top: nextTop, pageIndex: this.dragState.pageIndex })
        },
        onDragUp() {
            this.unbindDrag()
        },
        unbindDrag() {
            this.dragState.active = false
            document.removeEventListener('mousemove', this.onDragMove)
            document.removeEventListener('mouseup', this.onDragUp)
        },
        toRequirementCode() {
            if (this.requirementElse.length === 2) return 2
            if (this.requirementElse[0] === 2) return 1
            return 0
        },
        getPageFields(pageIndex) {
            return this.componentFields.filter(item => Number(item.pageIndex || 0) === Number(pageIndex))
        },
        submitBatch() {
            if (!this.formItem.task_name) return this.$Message.warning('请填写任务名称')
            if (!this.formItem.start_time || !this.formItem.end_time) return this.$Message.warning('请选择签约截止日期')
            if (this.formItem.end_time && this.formItem.end_expired && (new Date(this.formItem.end_time).getTime() > new Date(this.formItem.end_expired).getTime())) {
                this.$Message.warning('合同有效日期结束时间必须大于签约截止日期结束时间')
                return
            }
            if (!this.formItem.name) return this.$Message.warning('请填写甲方真实姓名')
            if (!/^1[3-9]\d{9}$/.test(String(this.formItem.paraticipant_phone || ''))) return this.$Message.warning('请填写正确的甲方手机号')
            if (this.formItem.type === 1 && !this.formItem.corporate_name) return this.$Message.warning('请填写甲方企业名称')
            if (!this.requirementElse.length) return this.$Message.warning('签署者至少选择一个')
            if (!Number(this.formItem.support_num) || Number(this.formItem.support_num) <= 0) return this.$Message.warning('请填写支持签署人数')

            const payload = {
                ...this.formItem,
                requirement: this.toRequirementCode(),
                label_id: Array.isArray(this.formItem.label_id) ? this.formItem.label_id.join(',') : String(this.formItem.label_id || ''),
                sms_status: this.formItem.is_sms ? '1' : '0',
                support_yinzhang: this.formItem.is_yinzhang ? '1' : '0',
                accessories_url: this.accessories_url,
                annex_file_id: [this.annex_file_id].concat(this.annex_img_ids || []).filter(Boolean).join(','),
                accessories_img: String(this.accessories_img || []),
                partya_template_cg_arr: this.partya_is_sign ? this.buildSubmitTemplateComponents(this.partya_arr) : [],
                partyb_template_cg_arr: this.buildSubmitTemplateComponents(this.partyb_arr),
                partya_is_sign: this.partya_is_sign
            }
            if (this.submiting) return
            this.submiting = true
            this.$Message.loading({ content: '发起中', duration: 0 })
            createBatch(withLaunchType(payload, LAUNCH_TYPE.NEW)).then((res) => {
                this.submiting = false
                this.$Message.destroy()
                this.$Message.success((res && res.msg) || '发起成功')
                this.currentStep = 3
                this.clearDraft()
            }).catch((err) => {
                this.submiting = false
                this.$Message.destroy()
                this.$Message.error((err && err.msg) || '发起失败')
            })
        }
    }
}
</script>

<style scoped lang="scss">
.batch-launch-page {
    background: #edf0f9;
    min-height: calc(100vh - 135px);
    overflow: auto;
}

.top-bar {
    background: #fff;
    border-radius: 10px;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    min-width: 1220px;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 12px;
}

.mode-display {
    display: flex;
    align-items: center;
    gap: 8px;
}

.mode-display__breadcrumb {
    font-size: 18px;
    color: #2f3a4f;
    font-weight: 600;
}

.mode-display__breadcrumb--current {
    color: #3f4f6a;
}

.step-wrap {
    width: 620px;
    flex: 0 0 620px;
}

.step-wrap /deep/ .ivu-steps-item.ivu-steps-status-process .ivu-steps-title {
    color: #2d8cf0;
}

.top-actions {
    display: flex;
    gap: 8px;
}

.content-wrap {
    margin-top: 12px;
    display: flex;
    gap: 12px;
    height: calc(100vh - 200px);
    min-width: 1220px;
}

.card {
    background: #fff;
    border-radius: 10px;
    padding: 16px;
}

.left-panel {
    flex: 1;
    min-height: 620px;
    min-width: 960px;
}

.right-panel {
    width: 360px;
    flex-shrink: 0;
    min-height: 620px;
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100vh - 200px);
}

.upload-top-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
}

.upload-top-label {
    font-size: 13px;
    color: #5d6d8a;
    min-width: 56px;
}

.upload-empty-wrap {
    height: 560px;
    border: 1px solid #edf1f8;
    border-radius: 8px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-empty-trigger {
    width: 200px;
    height: 200px;
    display: flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
}

/deep/ .upload-empty-trigger .ivu-upload,
/deep/ .upload-empty-trigger .ivu-upload-select {
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-empty-center {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.upload-empty-tip {
    margin-top: 10px;
    font-size: 14px;
    color: #7e879b;
}

.upload-box {
    min-height: 560px;
    border: 1px solid #edf1f8;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.upload-ready {
    width: 100%;
    padding: 10px 8px;
    box-sizing: border-box;
    text-align: center;
}

.upload-tip {
    margin-top: 8px;
    color: #8a94a6;
    font-size: 13px;
}

.upload-contract-preview {
    margin-top: 12px;
}

.contract-pages-wrap {
    height: 560px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    -webkit-overflow-scrolling: touch;
}

.contract-page-item {
    flex: 0 0 auto;
    width: 800px;
    height: 1132px;
    background: #fff;
    border: 1px solid #e4eaf9;
    box-shadow: 0 2px 8px rgba(27, 39, 66, 0.06);
    margin-bottom: 0;
    overflow: hidden;
}

.contract-page--upload {
    width: 800px;
    height: 1132px;
    margin-bottom: 8px;
}

.contract-page {
    width: 800px;
    height: 1132px;
    margin: 0 auto;
    position: relative;
    background: #fff;
}

.contract-page-img,
.contract-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    user-select: none;
}

.component-overlay {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}

.component-field > span {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.component-field {
    cursor: move;
}

.component-no-field > span {
    display: block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.component-no-field {
    cursor: default;
    border: 1px dashed #165ba5 !important;
    background: transparent !important;
    opacity: 1;
    user-select: none; 
    -webkit-user-select: none;
}

.sign-field {
    position: absolute;
    border: 1px solid #7ec7be;
    background: #eaf9f6;
    // border-radius: 3px;
    // padding: 2px 3px;
    box-sizing: border-box;
    color: #2f645d;
    display: flex;
    justify-content: space-between;
    pointer-events: auto;
}

.component-field-ops {
    position: absolute;
    left: calc(100% + 4px);
    top: 0;
    display: flex;
    align-items: center;
    gap: 2px;
}

.component-field-op-icon {
    width: 25px;
    height: 25px;
    cursor: pointer;
    object-fit: contain;
}

.template-action-wrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    padding: 10px 0;
    white-space: nowrap;
    flex-wrap: nowrap;
}

/deep/ .template-action-btn.ivu-btn {
    min-width: 86px;
    height: 32px;
    padding: 0 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    line-height: 30px;
    text-align: center;
    background: #fff;
    box-shadow: none;
}

/deep/ .template-action-btn--preview.ivu-btn {
    color: #5b82e6;
    border-color: #7ea0ee;
}

/deep/ .template-action-btn--use.ivu-btn {
    color: #53bfb8;
    border-color: #84d9d4;
}

.signer-item {
    position: relative;
    border: 1px solid #e8ecf3;
    border-radius: 8px;
    padding: 12px 10px 10px;
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(31, 45, 61, 0.08);
}

.signer-item--enterprise,
.party-card--a {
    background: #F0F6FF;
}

.signer-item--person,
.party-card--b {
    background: #E6F6F5;
}

.signer-head,
.party-head {
    display: flex;
    align-items: center;
    gap: 6px;
    padding-right: 4px;
    margin-bottom: 8px;
    font-weight: 600;
}

.setting-poptip {
    margin-left: auto;
    position: relative;
    z-index: 3;
    flex-shrink: 0;
}

.setting-link {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    font-size: 12px;
    color: #4877e8;
    cursor: pointer;
    text-align: right;
}

.field-row,
.party-field {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.field-label,
.party-field-label {
    font-size: 12px;
    color: #5d6d8a;
    width: 72px;
    flex-shrink: 0;
    text-align: right;
}

.field-row /deep/ .ivu-input-wrapper {
    flex: 1;
}

.req {
    color: #f04646;
    margin-right: 4px;
}

.save-row {
    margin-top: 14px;
    margin-left: 82px;
    color: #5d6d8a;
    font-size: 12px;
}

.setting-panel {
    width: 320px;
    padding: 4px 0;
}

/deep/ .ivu-poptip-popper {
    z-index: 3000 !important;
}

.setting-row {
    margin-bottom: 8px;
    line-height: 1.8;
    color: #394863;
    display: flex;
    align-items: flex-start;
    gap: 6px;
    flex-wrap: wrap;
}

.setting-label {
    display: inline-block;
    min-width: 116px;
    color: #5d6d8a;
    flex: 0 0 116px;
}

.setting-check-group {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: 12px;
    row-gap: 4px;
}

.right-panel /deep/ .ivu-checkbox-group {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 14px;
}

.setting-label {
    min-width: 116px;
    flex: 0 0 116px;
}

.sort-switch {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
}

.sort-switch-control {
    transform: none;
}

.sort-switch-text {
    font-size: 12px;
}

.sort-switch /deep/ .ivu-switch {
    width: 62px;
    height: 24px;
    line-height: 22px;
}

.sort-switch /deep/ .ivu-switch-inner {
    font-size: 12px;
}

.sort-switch /deep/ .ivu-switch:after {
    width: 20px;
    height: 20px;
}

.component-tool {
    margin-top: 4px;
}

.tool-title {
    font-size: 16px;
    font-weight: 600;
    color: #1b2742;
    margin-bottom: 10px;
}

.component-empty-tip {
    font-size: 12px;
    color: #8a94a6;
    margin-top: 8px;
}

.component-signer-card {
    border: 1px solid #e8ecf3;
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 10px;
    background: #fff;
}

.component-signer-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin-bottom: 8px;
}

.component-signer-name {
    font-size: 12px;
    color: #394863;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.component-signer-count {
    font-size: 12px;
    color: #8a94a6;
}

.tool-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
}

.tool-item {
    border: 1px solid #e8ecf3;
    border-radius: 6px;
    min-width: 0;
    height: 64px;
    font-size: 12px;
    color: #4d5f80;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    cursor: pointer;
}

.tool-item:hover {
    border-color: #4877e8;
    color: #4877e8;
}

.tool-item--disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.tool-item--disabled:hover {
    border-color: #e8ecf3;
    color: #4d5f80;
}

.tool-item-text {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
}

.setting-row /deep/ .ivu-checkbox-wrapper-disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.tool-item-img {
    width: 20px;
    height: 20px;
    object-fit: contain;
    flex-shrink: 0;
}

.done-card {
    min-height: 620px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
}

.done-success-img {
    width: 260px;
    max-width: 100%;
    object-fit: contain;
}

.done-text {
    font-size: 42px;
    color: #4c5a74;
}

.done-back-btn {
    min-width: 120px;
    margin-top: 8px;
}
</style>
